import request from '@/utils/request'

// 提案計画登録
// API(post) url : /v1/api/proposalBase
export function submit(data) {
  return request({
    url: '/api/proposalBase',
    method: 'post',
    data,
  })
}
// 变更照会の商品明细数据
// API(get) url: '/v1/api/proposalItemDetail/proposal/item-details'
export function getcommodityDetailList(data) {
  return request({
    url: `/api/proposalItemDetail/proposal/item-details?id=${data}`,
    method: 'get',
    data,
  })
}
// 变更照会详细信息数据
// export function getDetailList(data) {
//   return request({
//     url: `/api/proposal/getdetailList?id=${data}`,
//     method: 'get',
//     data,
//   })
// }
// 建設工事提案計画登録
// export function getSaveList(data) {
//   return request({
//     url: '/api/proposalBase',
//     method: 'post',
//     data,
//   })
// }
// 变更照会予定売上額・予定原価額数据
// export function getcommodityDetailYsList(data) {
//   return request({
//     url: `/api/proposal/getcommodityDetailYsList?id=${data}`,
//     method: 'get',
//     data,
//   })
// }

export function pageList(data) {
  return request({
    url: '/api/proposal/pageList',
    method: 'post',
    data,
  })
}
export function getstWaiInfo() {
  return request({
    url: '/api/proposal/getstWaiInfo',
    method: 'get',
  })
}
export function getProposalItemDetail() {
  return request({
    url: '/api/getProposalItemDetail',
    method: 'get',
  })
}
export function getYear() {
  return request({
    url: '/api/proposal/getYear',
    method: 'get',
  })
}

export function getProposalDetail(data) {
  return request({
    url: '/api/proposalDetail/many',
    method: 'post',
    data,
  })
}
